module.exports = __webpack_public_path__ + "mail.png?8d7c359bc7f2ebcfef0dffbcdb6d5760";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mail.png
// module id = 86
// module chunks = 0